var map = {
	"./BaaS.png": "8b39",
	"./Background_Footer.png": "632f",
	"./Background_Vision_Mission.png": "4939",
	"./Button_DigiBos.png": "771a",
	"./Button_KasPro.png": "8914",
	"./Button_KreditPro.png": "0d4c",
	"./Button_Next.png": "20ff",
	"./Button_Prev.png": "3148",
	"./Button_RemitPro.png": "ed46",
	"./ContactUs_Footer.png": "55dd",
	"./FaaS.png": "8420",
	"./Footer_Background.png": "2f0d",
	"./Footer_Session.png": "f3e6",
	"./Hover_Brachless_Banking.png": "f3cb",
	"./Hover_Cash_Management.png": "9184",
	"./Hover_KasPro_Bank.png": "83aba",
	"./Hover_MSME.png": "9123",
	"./Hover_Merchant_on_Record.png": "cbc9",
	"./Hover_Money_Transfer.png": "cbee",
	"./Hover_Online_Transaction.png": "5e22",
	"./Hover_Serve_Unbanked.png": "afe5",
	"./Logo_Bank_Indonesia.png": "84c4",
	"./Logo_DigiBos_White.png": "24f3",
	"./Logo_Digiasia_Color.png": "130a",
	"./Logo_Digiasia_White1.png": "211c",
	"./Logo_Digiasia_White2.png": "7737",
	"./Logo_KasPro_White.png": "2d78",
	"./Logo_KreditPro_White.png": "4b34",
	"./Logo_OJK.png": "9944",
	"./Logo_OJK_2.png": "6dfb",
	"./Logo_PCI_DSS.png": "caa5",
	"./Logo_RemitPro_White.png": "74ae",
	"./Ornamen_Bulat_01.png": "0804",
	"./Ornamen_Bulat_02.png": "46fa",
	"./Ornamen_Bulat_03.png": "8653",
	"./Ornamen_Bulat_04.png": "c03a",
	"./Ornamen_Bulat_05.png": "a514",
	"./Our_Milestones_Background.png": "a0a8",
	"./Product_Services_1.png": "0ada",
	"./Product_Services_2.png": "f240",
	"./Product_Services_3.png": "0973",
	"./Product_Services_4.png": "541f",
	"./Product_Services_Close.png": "c127",
	"./Product_Services_Open.png": "2d3a",
	"./Profile_Picture.jpeg": "2be5",
	"./Rheinland_Certified_ISO27001_2022.png": "d871",
	"./Rheinland_Certified_PCIDSS.png": "d552",
	"./SaaS.png": "a377",
	"./businessplan.jpeg": "85ee",
	"./default.png": "d18b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6fb";